import { render, staticRenderFns } from "./PrizesCreate.vue?vue&type=template&id=100105aa"
import script from "./PrizesCreate.vue?vue&type=script&lang=js"
export * from "./PrizesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports